export default "__VITE_ASSET__CXu6PXSW__"